<template>
  <div class="table">
    <!-- <draggable
      v-model="list"
      @end="end"
      :disabled="activeName == 4 ? false : true"> -->
      <div
        class="tables" style="padding-top: 5px;"
        v-for="(item, i) in list"
        :key="i"
        :style="{ background: item.isGao == 1 ? '#f4f1df!important' : '' }">
        <div class="biaotous bgn" style="width: 68.7px;position: relative;">
          <span style="margin-top: 10px;font-size: 20px;font-weight: bold;" :style="{color:dataCOLOR(item)}">{{ item.sort_id }}</span>
          
          <el-tag size="mini" type="success" v-if="(parseInt($parent.detail.score) - parseInt(item.yugu_score))>15"
          style="position: absolute;left: 45px;top: -5px;"
          >保</el-tag>
          <el-tag size="mini" v-if="((parseInt($parent.detail.score) - parseInt(item.yugu_score))<=15) && parseInt($parent.detail.score)>=parseInt(item.yugu_score)"
          style="position: absolute;left: 45px;top: -5px;"
          >稳</el-tag>
          <el-tag size="mini" v-if="parseInt(item.yugu_score)>parseInt($parent.detail.score)" type="danger"
          style="position: absolute;left: 45px;top: -5px;"
          >冲</el-tag>
        </div>
        <div class="biaotous bgn" style="width: 114.5px;padding-top: 5px;padding-bottom: 5px;">
          <el-button
            type="primary"
            size="small"
            @click="addClick(item)"
            v-if="!item.is_result">
            添加
          </el-button>
          <el-button
            type="danger"
            size="small"
            @click="delClick(item,i)"
            v-if="item.is_result">
            移除
          </el-button>
        </div>
        <div
          class="biaotous bgn"
          :style="{ width: activeName == 3 ? '1137px' : '1145px' }"
          style="justify-content: flex-start">
          <div class="">
            <div class="d-inline-block" style="display: flex;align-items: center;">
              <div class="text-danger text-decoration-none">
                <span style="font-size: 160%;cursor: pointer;color: #f3545d;" @click="collegeClick(item)">
                  {{ item.collegeName }}
                  <span v-if="item.collegeNameRemark">
                    {{ item.collegeNameRemark }}
                  </span>
                  [{{ item.collegeNature }}]
                </span>
              </div>
                <div>
                  <span style="margin: auto 10px;font-size: 120%;cursor: pointer;color: #409EFF;" @click="$refs.collegeAllData.show(item)">
                    全部专业
                  </span>
                </div>
              <a
                :href="item.vr"
                class="text-decoration-none"
                target="_blank"
                v-if="item.vr"
                title="地图街景">
                <img src="@/assets/jiejing.png" alt="" class="jiejing" style="width: 30px;height: 30px;" />
              </a>
              <span class="text-muted mr-3" style="font-size:   16px;">
                <span v-if="item.collegeProvince">{{ item.collegeProvince }}</span>
                <span v-if="item.collegeCity">,{{ item.collegeCity }}</span>
                <span v-if="item.collegeLevel">,{{item.collegeLevel}}</span>
              </span>
              <el-tag
                size="mini"
                type="danger"
                style="margin-left: 5px"
                v-if="item.is985 == '是'">
                985
              </el-tag>
              <el-tag
                size="mini"
                type="danger"
                style="margin-left: 5px"
                v-if="item.is211 == '是'">
                211
              </el-tag>
              <el-tag
                size="mini"
                type="danger"
                style="margin-left: 5px"
                v-if="item.two_yiliu == '是'">
                双一流
              </el-tag>
              <el-tag size="mini" style="margin-left: 5px">
                {{ item.collegeNature }}
              </el-tag>
              <el-tag size="mini" type="danger" style="margin-left: 5px">
                {{ item.collegeType }}
              </el-tag>
              <el-tag size="mini" v-if="item.isGuo" type="danger" style="margin-left: 5px">
                {{ item.isGuo }}
              </el-tag>
              <el-badge
                value="硕"
                type="warning"
                class="item"
                v-if="item.shuoshiNum"></el-badge>
              <el-badge
                value="博"
                type="danger"
                class="item"
                v-if="item.boshiNum"></el-badge>
              <el-badge
                value="保"
                type="success"
                class="item"
                v-if="item.isBao == 1"></el-badge>
            </div>
            <div class="text-dark" style="font-size: 120%;margin-top: 10px;">
              <span
                class="d-inline-block text-truncate w-100 might-overflow"
                style="display: flex; align-items: center">
                <div
                  class="text-primary text-decoration-none"
                  style="display: flex; align-items: center;cursor: pointer;" @click="majorDetail(item)">
                  {{ item.specialty_title }}
                  <span v-if="item.major_field">{{ item.major_field }}</span>
                </div>
                
                <div>
                  <el-tag
                          size="mini"
                          type="danger"
                          style="margin-left: 5px"
                          v-if="
                            !item.current_year_red_score &&
                            !item.qu_year_red_score &&
                            !item.qian_year_red_score
                          ">
                          新专业
                        </el-tag>
                </div>
                <div>
                  <el-tag
                          size="mini"
                          style="margin-left: 5px"
                          v-if="item.cengci"
                          >
                          {{item.cengci.includes('职')?'职业教育':item.cengci}}
                        </el-tag>
                </div>
                <div>
                  <el-tag
                          size="mini"
                          type="danger"
                          style="margin-left: 5px"
                          v-if="
                            item.collegeNameRemark&&item.collegeNameRemark.includes('新更名')
                          ">
                          新更名
                        </el-tag>
                </div>
                 <span style="margin-left: 15px;">
                  学制：{{ item.schooling_length }},学费：{{ item.tuition_fee==-1?"待定":item.tuition_fee }},专业代码：{{ item.specialty_code }};
                 </span>
              </span>
            </div>
            <div
            v-if="item.major_remark"
              style="margin-top: 10px;width: 825px;">
              专业简注：{{ item.major_remark }};
            </div>
          </div>
        </div>
        <div
          class="biaotous bgn"
          v-if="activeName != 3"
          style="
            width: 137.4px;
            flex-direction: column;
            align-items: flex-start;
          ">
          <div style="margin-left: 10px">高校：{{ item.ruan_pai }}</div>
          <div style="margin-top: 10px; margin-left: 10px">
            专业：{{ majorReturn(item) }}
            <span v-if="item.soft_ranking">
              ，{{item.soft_ranking || "--"}}
            </span>
          </div>
          <div style="margin-top: 10px;">
            <el-tag
                    size="mini"
                    type="danger"
                    style="margin-left: 5px"
                    v-if="
                      item.tese_major_lei &&
                      item.tese_major_lei.includes(item.majors) &&
                      userinfo.isZeng != 1
                    ">
                    国家特色专业
                  </el-tag>
          </div>
          <div style="margin-top: 10px;">
            <el-tag
                    size="mini"
                    type="success"
                    style="margin-left: 5px"
                    v-if="
                      item.tw0_jianshe_lei && item.tw0_jianshe_lei.includes(item.majors)  &&
                      userinfo.isZeng != 1
                    ">
                    双一流建设学科
                  </el-tag>
          </div>
        </div>
        <div
          class="biaotous bgn"
          style="flex-direction: column"
          :style="{ width: activeName == 3 ? '175px' : '90px' }">
          <el-tag size="small" type="danger">{{ item.the_second }}</el-tag>
        </div>
        <div
          class="biaotous bgn"
          :style="{ width: activeName == 3 ? '175px' : '90px' }"
          style="flex-direction: column"
          v-if="activeName == 3">
          {{item.planned_number}}
        </div>
        <div
          class="biaotous bgn"
          :style="{ width: activeName == 3 ? '175px' : '90px' }"
          style="flex-direction: column"
          v-if="activeName == 3">
          {{item.schooling_length}}
        </div>
        <div
          class="biaotous bgn"
          :style="{ width: activeName == 3 ? '175px' : '90px' }"
          style="flex-direction: column"
          v-if="activeName == 3">
          {{item.tuition_fee}}
        </div>
        <div
          class="biaotous bgn"
          v-if="activeName != 3"
          style="
            width: 343.5px;
            background: none;
            flex-direction: column;
            justify-content: flex-start;
            height: auto;
          ">
          <div class="xian">
            <div class="b01 bb">
              <el-tooltip
                class="item"
                effect="dark"
                content="招生计划"
                placement="top">
                <img src="@/assets/yuce01.png" class="yuce" alt="" />
              </el-tooltip>

              <span style="margin-left: auto">
                {{ item.planned_number || "-" }}
              </span>
            </div>
            <div class="b02 bb" style="justify-content: center">
              {{ item.current_jihua || "-" }}
            </div>
            <div class="b02 bb" style="justify-content: center">
              {{ item.qu_jihua || "-" }}
            </div>
            <div class="b02 bb" style="justify-content: center">
              {{ item.qian_jihua || "-" }}
            </div>
          </div>
          <div class="xian">
            <div class="b01 bb">
              <el-tooltip
                class="item"
                effect="dark"
                content="分数线"
                placement="top">
                <img src="@/assets/yuce02.png" class="yuce" alt="" />
              </el-tooltip>
              <!--这里需要判断的算法还是直接展示分数-->
              <span
                v-if="item.collegeLevel == '本科'"
                style="margin-left: auto; color: red">
                <span
                  style="margin-left: auto; color: red"
                  v-if="form.yugu_zhanshi == 1">
                  {{ item.yugu_score }}
                </span>
                <span
                  style="margin-left: auto; color: red"
                  v-if="form.yugu_zhanshi == 2">
                  {{ item.yugu_score || "-" }}
                </span>
              </span>
              <span
                v-if="item.collegeLevel == '专科'"
                style="margin-left: auto; color: red">
                <span
                  style="margin-left: auto; color: red"
                  v-if="form.yugu_zhuanke == 1">
                  {{ item.yugu_score }}
                </span>
                <span
                  style="margin-left: auto; color: red"
                  v-if="form.yugu_zhuanke == 2">
                  {{ item.yugu_score || "-" }}
                </span>
              </span>
            </div>
            <div class="b02 bb" style="justify-content: center">
              <span style="color: red">
                {{ item.current_year_red_score || "-" }}
              </span>
              ({{ item.current_year_min_score || "-" }})
            </div>
            <!--修改-->
            <div class="b02 bb" style="justify-content: center">
              <span style="color: red">
                {{ item.qu_year_red_score || "-" }}
              </span>
              ({{ item.qu_year_min_score || "-" }})
            </div>
            <div class="b02 bb" style="justify-content: center">
              <span style="color: red">
                {{ item.qian_year_red_score || "-" }}
              </span>
              ({{ item.qian_year_min_score || "-" }})
            </div>
          </div>
          <div class="xian">
            <div class="b01 bb">
              <el-tooltip
                class="item"
                effect="dark"
                content="征集计划数（一次征集/二次征集）"
                placement="top">
                <img src="@/assets/yuce03.png" class="yuce" alt="" />
              </el-tooltip>
              <span style="margin-left: auto; color: #35cd3a">
                <span style="color: red">
                  {{ item.mingnian_one_zhengji || "-" }}
                </span>
                /{{ item.mingnian_two_zhengji || "-" }}
              </span>
            </div>
            <div
              class="b02 bb"
              style="justify-content: center; color: #35cd3a">
              <span style="color: red">{{ item.current_zhengji1 || "-" }}</span>
              /{{ item.current_zhengji2 || "-" }}
            </div>
            <div
              class="b02 bb"
              style="justify-content: center; color: #35cd3a">
              <span style="color: red">{{ item.qu_zhengji1 || "-" }}</span>
              /{{ item.qu_zhengji2 || "-" }}
            </div>
            <div
              class="b02 bb"
              style="justify-content: center; color: #35cd3a">
              <span style="color: red">{{ item.qian_zhengji1 || "-" }}</span>
              /{{ item.qian_zhengji2 || "-" }}
            </div>
          </div>
          <div class="xian">
            <div class="b01 bb">
              <el-tooltip
                class="item"
                effect="dark"
                content="位次"
                placement="top">
                <img src="@/assets/yuce04.png" class="yuce" alt="" />
              </el-tooltip>
              <span
                style="margin-left: auto; color: #177dff"
                v-if="form.yugu_zhanshi == 1">
                {{ item.yugu_seat || "-" }}
              </span>
              <span
                style="margin-left: auto; color: #177dff"
                v-if="form.yugu_zhanshi == 2">
                {{ item.yugu_seat || "-" }}
              </span>
            </div>
            <div
              class="b02 bb"
              style="justify-content: center; color: #177dff">
              {{ item.current_year_min_beat || "--" }}
            </div>
            <div
              class="b02 bb"
              style="justify-content: center; color: #177dff">
              {{ item.qu_year_min_beat || "-" }}
            </div>
            <div
              class="b02 bb"
              style="justify-content: center; color: #177dff">
              {{ item.qian_year_min_beat || "-" }}
            </div>
          </div>
        </div>
      </div>
    <!-- </draggable> -->
    <!-- <tableVue v-loading="loading" :activeName="String(activeName)" :lists="list" :form="form" /> -->
    <tableVue1 ref="collegeAllData" :form="form" :aspid="aspid"/>
       <!-- <selectCollege ref="collegeData" /> -->
  </div>
</template>

<script>
import {
  add,
  del,
  updateAll,
  updateExt,
  codeDelete,
} from "@/api/gw/volunteerresult.js";
import Sortable from "sortablejs";
import tableVue1 from "./tabledialog.vue";
import draggable from "vuedraggable";
import { mapGetters } from "vuex";
export default {
  components: {
    draggable,
    tableVue1
  },
  computed: {
    ...mapGetters(["userinfo"]),
  },
  data() {
    return {
      list: [],
    };
  },
  props: {
    activeName: {
      type: String,
      default: "1",
    },
    aspid: {
      type: Number,
      default: 0,
    },
    lists: {
      type: Array,
      defalut: [],
    },
    form: {
      type: Object,
      default: {},
    },
    detail: {
      type: Object,
      default: {},
    },
  },
  watch: {
    lists: {
      handler(newVal, oldVal) {
        this.list = newVal;
      },
      deep: true,
    },
  },
  mounted() {},
  methods: {
        //颜色：在志愿单里，预估分高于学生分的，志愿单里的序号用红色，低于学生分14分的，用绿色，低于学生分15分以下的用其它颜色
        dataCOLOR(item){
        let yugu_score = parseInt(item.yugu_score);
        let score = parseInt(this.$parent.detail.score);
        if(yugu_score>score){
          return "red";
        }
        if((score-yugu_score)<=15&&(score>=yugu_score)){
          return "#409EFF";
        }
        if((score-yugu_score)>15){
          return "#67C23A";
        }
    },
    //跳转学校详情
    collegeClick(item){
      const routerUrl = this.$router.resolve({
          path: "/SchoolDetail?isCha=1&n=" + item.collegiate_id,
        });
        window.open(routerUrl.href, "_blank");
    },
    //跳转专业详情
    majorDetail(item){
      const routerUrl = this.$router.resolve({
          path: "/MajorDetail?isCha=1&n=" + item.mojor_id,
        });
        window.open(routerUrl.href, "_blank");
    },
    end(event) {
      // 获取新的顺序
      let list = [...this.list];
      const newOrder = list.map((item, index) => ({
        ...item,
        position: index,
      }));
      this.$parent.list = newOrder;
      let arr = [];
      newOrder.forEach((r, j) => {
        arr.push({
          volunteer_result_id: r.volunteer_result_id,
          sort_id: Number(j + 1),
          // collegeName:r.collegeName,
          // specialty_title:r.specialty_title
        });
      });

      //此时走更新
      updateAll({
        list: arr,
      })
        .then(() => {

        })
        .finally(() => {
          this.$parent.yichuList();
        });
    },
    // 排序修改方法
    updateExt(row, field) {
      if (row.volunteer_result_id) {
        updateExt({
          volunteer_result_id: row.volunteer_result_id,
          [field]: row[field],
        }).then((res) => {
          this.$notify({
            title: '操作成功',
            message: '',
            duration:2000,
            type: 'success'
        });
          this.$parent.yichuList();
        });
      }
    },
    //添加
    addClick(item) {
      let that = this;
      this.$set(item, "is_result", !item.is_result);
      let form = {
        volunteer_id: this.$parent.detail.volunteer_id,
        code: item.code,
        specialty_code: item.specialty_code,
      };
      // const loading = this.$loading({
      //   lock: true,
      //   text: "添加中",
      //   spinner: "el-icon-loading",
      //   background: "rgba(0, 0, 0, 0.7)",
      // });
      add(form)
        .then(() => {
          this.$notify({
            title: '已成功将指定专业添加到志愿列表。',
            message: '',
            duration:2000,
            type: 'success'
        });
          this.$parent.Volunteer_currentCount();
        })
        .finally(() => {
          loading.close();
        });
    },
    updateCount(){
      this.$parent.Volunteer_currentCount();
    },
    //移除
    //移除
    delClick(item, i) {
      let that = this;
            if(this.activeName==4){
               this.$parent.list.splice(i,1);
               //进行重新排序
               this.$parent.list.forEach((r,j)=>{
                r.sort_id = j+1
               })
               this.$parent.newZhiyuan = this.$parent.list
            }else{
              this.$set(item, "is_result", !item.is_result);
            }
        codeDelete({
          volunteer_id: that.$parent.detail.volunteer_id,
          specialty_code: item.specialty_code,
          code: item.code,
        })
          .then(() => {
            this.$notify({
              title: "已成功移除指定专业",
              message: "",
              duration: 2000,
              type: "success",
            });
            this.$parent.Volunteer_currentCount();
          })
          .finally(() => {
            loading.close();
          });
    },
    //算法展示
    suanfa(item) {
      //（当年位次/当年总计划*0.5+去年位次/去年总计划数*0.3+前年位次/前年总计划数*0.2）*预测年招生计划数
      let seat = item.mingnian_seat || 0; //当年位次
      let qunian_seat = item.qunian_seat || 0; //去年位次
      let qiannian_seat = item.qiannian_seat || 0; //前年位次
      let dangNum = 0; //当年做计划
      let qunianNum = 0; //去年总计划
      let qianNum = 0; //前年总计划
      let yuceNum = 0; //预测年招生计划

      if (item.batch == "本科批" && item.group_d == "物理科目组合") {
        dangNum = this.form.dangyear_benke_wuli_num || 0;
        qunianNum = this.form.qunian_benke_wuli_num || 0;
        qianNum = this.form.qiannian_benke_wuli_num || 0;
        yuceNum = this.form.yugu_benke_wuli_num || 0;
      }
      if (item.batch == "本科批" && item.group_d == "历史科目组合") {
        dangNum = this.form.dangyear_benke_lishi_num || 0;
        qunianNum = this.form.qunian_benke_lishi_num || 0;
        qianNum = this.form.qiannian_benke_lishi_num || 0;
        yuceNum = this.form.yugu_benke_lishi_num || 0;
      }
      if (item.batch == "专科批" && item.group_d == "物理科目组合") {
        dangNum = this.form.dangyear_zhuanke_wuli_num || 0;
        qunianNum = this.form.qunian_zhuanke_wuli_num || 0;
        qianNum = this.form.qiannian_zhuanke_wuli_num || 0;
        yuceNum = this.form.yugu_zhuanke_wuli_num || 0;
      }
      if (item.batch == "专科批" && item.group_d == "历史科目组合") {
        dangNum = this.form.dangyear_zhuanke_lishi_num || 0;
        qunianNum = this.form.qunian_zhuanke_lishi_num || 0;
        qianNum = this.form.qiannian_zhuanke_lishi_num || 0;
        yuceNum = this.form.yugu_zhuanke_lishi_num || 0;
      }
      let num =
        ((seat / dangNum) * 0.5 +
          (qunian_seat / qunianNum) * 0.3 +
          (qiannian_seat / qianNum) * 0.2) *
        yuceNum;
      //此时算出的是位次，此时需要用位次查询预测年的对应分数
      return parseInt(num);
    },
    //检测专业是A+还是其他
    majorReturn(item) {
      if (item.ajia_major && item.ajia_major.includes(item.majors)) {
        return "A+";
      } else if (item.as_major && item.as_major.includes(item.majors)) {
        return "A";
      } else if (item.a_jian_major && item.a_jian_major.includes(item.majors)) {
        return "A-";
      } else if (item.b_jia_major && item.b_jia_major.includes(item.majors)) {
        return "B+";
      } else if (item.b_majors && item.b_majors.includes(item.majors)) {
        return "B";
      } else if (item.b_jian_major && item.b_jian_major.includes(item.majors)) {
        return "B-";
      } else if (item.c_jia_major && item.c_jia_major.includes(item.majors)) {
        return "C+";
      } else if (item.c_major && item.c_major.includes(item.majors)) {
        return "C";
      } else if (item.c_jian_major && item.c_jian_major.includes(item.majors)) {
        return "C-";
      } else {
        return "无";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './scss/framework.scss';

.bgn {
  background: none;
  color: #333;
}

.table {
  width: 100%;

  .tables {
    width: 100%;
    display: flex;
    background: #fff;
    // height: 80px;
  }

  .tables:nth-child(2n) {
    background: #f5fbff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/volunteer/table.vue